import { ColoursObj } from "@eventr/common-storybook";
import { useActivityFeed } from "feat/activity-feed/hooks";
import { useGlobalRouter } from "feat/globalRouter/useGlobalRouter";
import { routes } from "routing";
import HitBoxIcon from "./HitBoxIcon";

export default function ActivityFeedButton({
  colour = ColoursObj.shades.shade5,
  align = "end",
}: {
  colour?: string;
  align?: "center" | "end";
}) {
  const { pushPath } = useGlobalRouter();
  const feed = useActivityFeed();
  const hasFeed = !!feed.length;

  return (
    <HitBoxIcon
      id="carousel-activity-feed"
      onClick={() => pushPath(routes.activityFeed.path)}
      icon={hasFeed ? "NotificationUnread" : "Notification"}
      colour={colour}
      align={align}
    />
  );
}
